import { useMutation, useQueryClient } from '@tanstack/react-query';
import { regionsApi } from '../api/regions.api';
import { isRegionHierarchyQuery } from './isRegionHierarchyQuery';
import { regionKeys } from './queryKeys';

export const useDeleteRegion = () => {
  const queryClient = useQueryClient();

  const deleteRegion = useMutation({
    mutationFn: (id: string) => regionsApi.deleteRegion(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: regionKeys.lists() });
      queryClient.invalidateQueries({ queryKey: regionKeys.tree() });
      queryClient.invalidateQueries({ queryKey: regionKeys.byCountryAndTypeAll() });
      queryClient.invalidateQueries({ predicate: isRegionHierarchyQuery });
    },
  });

  return {
    deleteRegion: deleteRegion.mutate,
    isDeleting: deleteRegion.isPending,
  };
};
